import type { IncomingMessage } from 'node:http'

const getHeaderValue = (value?: string | string[]): string | undefined =>
  Array.isArray(value) ? value[0] : value

export interface RequestHostInfo {
  host?: string
  forwardedProtocol?: string
}

export const getRequestHostInfo = (req?: IncomingMessage | null): RequestHostInfo => {
  if (!req) return {}

  const forwardedHost = getHeaderValue(req.headers?.['x-forwarded-host'])
  const rawHost = getHeaderValue(req.headers?.host)
  const forwardedProtocol = getHeaderValue(req.headers?.['x-forwarded-proto'])

  return {
    host: forwardedHost || rawHost || undefined,
    forwardedProtocol: forwardedProtocol || undefined,
  }
}
